module.exports = __webpack_public_path__ + "static/media/pecuaria-5.176141a3.jpg";